import { defa } from 'defa-object';
import Model    from 'scripts/poppet/model';

/**
 * defa.models.Subscription
 * The DEFA Subscription Model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );

const apiHost = defa.vars.apiHost;

const api = {
	subscriptions    : apiHost + '/subscriptions',
	disable          : apiHost + '/subscriptions/%s/renewable',
	transfer         : apiHost + '/subscriptions/%s/transfer',
	owner            : apiHost + '/subscriptions/%s/owner',
	replace          : apiHost + '/subscriptions/%s/subscriptionpackage',
};

const Subscription = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.subscriptions,
	
	defaults: {
		active                 : !1,
		unit                   : !1,
		owner                  : !1,
		createdDate            : '',
		validFrom              : '',
		transientAlias         : '',
		transientCanRenew      : !1,
		transientExpirationDate: '',
		
		// SubscriptionPackage
		transientName     : '',
		transientPackageId: null,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Separates objects and stores information in the channel.
	 * @overwrite
	 *
	 * @param  {Object} response  The server response, which can be a bundle of linked objects.
	 * @return {Object}           The parsed response, now only containing the correct variables for a Subscription.
	 */
	parse: function ( response ) {
		
		if ( response.customer ) {
			channel.request( 'customers' ).add( response.customer, { merge: true } );
		}
		
		if ( response.unit ) {
			channel.request( 'units' ).add( response.unit, { merge: true } );
		}
		
		if ( response.subscriptionPackage ) {
			channel.request( 'subscriptionPackages' ).add( response.subscriptionPackage, { merge: true } );
		}
		
		if ( response.alarmCentral ) {
			channel.request( 'alarmCentrals' ).add( response.alarmCentral, { merge: true } );
		}
		
		if ( response.insuranceCompany ) {
			channel.request( 'insuranceCompanies' ).add( response.insuranceCompany, { merge: true } );
		}
		
		if ( response.settingsAutomotive ) {
			channel.request( 'settingsAutomotives' ).add( response.settingsAutomotive, { merge: true } );
		}
		
		if ( response.subscription ) {
			response = response.subscription;
		}
		
		// add to channel
		channel.request( 'subscriptions' ).add( response, { merge: true } );
		
		return response;
	},
	
	/**
	 * Disable the current subscription.
	 * @void
	 */
	disable: function () {
		this.save( {
			renewable: false,
		}, {
			patch: true,
			url  : api.disable.replace( '%s', this.get( 'id' ) ),
		} );
	},
	
	/**
	 * Enable the current subscription.
	 * @void
	 */
	enable: function () {
		this.save( {
			renewable: true,
		}, {
			patch: true,
			url  : api.disable.replace( '%s', this.get( 'id' ) ),
		} );
	},
	
	/**
	 * Get this subscriptions unit type.
	 * @return {String} The unit type of the current subscription.
	 */
	getUnitType: function () {
		return channel.request( 'units' ).get( this.get( 'unit' ) ).getUnitType();
	},
	
	/**
	 * Saves a new owner of the subscription.
	 * @param {Object} options  An object containing both a new owner and a token.
	 * @void
	 */
	saveOwner: function ( options ) {
		
		this.save( options, {
			patch: true,
			url  : api.owner.replace( '%s', this.get( 'id' ) ),
		} );
	},
	
	/**
	 * Initiates the transfer of a subscription.
	 * @param {String} email  The email of the (hopefully) new owner.
	 * @void
	 */
	transfer: function ( email ) {
		
		let self = this,
			url  = api.transfer.replace( '%s', this.get( 'id' ) );
		
		$.ajax( {
			 type       : 'POST',
			 url        : url,
			 contentType: 'application/json',
			 data       : JSON.stringify( {
				 email: email,
			 } )
		 } )
		 .done( function ( response ) {
			 self.set( response ).trigger( 'transferred', self, email );
		 } )
		 .fail( function ( response ) {
			 self.trigger( 'error', self, response );
		 } );
	},
	
	/**
	 * Patches this subscription's current subscription package.
	 * @param {object} options  A options object containing a subscriptionPackage id, and an optional promotionCode.
	 * @void
	 */
	replacePackage: function ( options ) {
		this.save( options, {
			patch: true,
			url  : api.replace.replace( '%s', this.get( 'id' ) ),
		} );
	},

} );

export default Subscription;